import React from "react";

import { Trans } from "@lingui/react/macro";

import {
  EmptyStateContainer,
  EmptyStateIcon,
  EmptyStateSubtext,
  EmptyStateTitle,
} from "@readai/common/components/EmptyStateContainer";
import ClockIcon from "@readai/icons/uui/Clock";

const NoTimesAvailable = () => (
  <EmptyStateContainer border="none">
    <EmptyStateIcon Icon={ClockIcon} />
    <EmptyStateTitle>
      <Trans>No times available</Trans>
    </EmptyStateTitle>
    <EmptyStateSubtext>
      <Trans>
        Oops, there are no times available in the selected timeframe. Please
        reach out to the calendar owner for more information.
      </Trans>
    </EmptyStateSubtext>
  </EmptyStateContainer>
);

export default NoTimesAvailable;
